var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{class:_vm.required ? 'required':'',attrs:{"value":_vm.district,"items":_vm.selectItems,"rules":_vm.validationRules,"color":"primary","label":"District"},on:{"change":function($event){return _vm.saveValue($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }